<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style lang="scss">
	body, html {
		font-family: 'Montserrat', sans-serif;
		font-size: 14px;
		padding: 0;
		margin: 0;
		background-color: #000;
		color: #fff;
		height: 100vh;
		overflow: hidden;
	}

	.button {
		display: block;
		padding: 18px;
		background-color: #CEB992;
		color: #ffffff;
		font-weight: bold;
		font-size: 16px;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		max-width: 100%;
		margin: 10px auto;
		border-radius: 2px;
		width: 100%;
		border: none;
		transition: all ease .2s;

		&:disabled {
			background-color: #CCCCCC;
			opacity: .5;
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue